import axios from 'axios';

// تعريف عنوان الخادم الأساسي
export const base = 'https://ssl.vipwellness-suite.de';

// إنشاء نسخة من axios مع الإعدادات الافتراضية
export const request = axios.create({
  baseURL: `${base}/api`,
  timeout: 30000, // زيادة مهلة الانتظار إلى 30 ثانية
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
  },
});

// إضافة معترض للطلبات
request.interceptors.request.use(
  (config) => {
    // إضافة رمز المصادقة إذا كان موجودًا
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// إضافة معترض للاستجابات
request.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    
    // إعادة تنسيق رسالة الخطأ
    const errorMessage = error.response?.data?.message || 
                         error.response?.data?.error || 
                         error.message || 
                         'Ein unerwarteter Fehler ist aufgetreten';
    
    // إنشاء كائن خطأ جديد مع الرسالة المعدلة
    const customError = new Error(errorMessage);
    customError.response = error.response;
    customError.status = error.response?.status;
    
    return Promise.reject(customError);
  }
);
